import Header from '../Header/Header';
import { CustomTable, ConfirmationPopup, SuccessModal, Pagination, Search,Loader } from '@ohif/ui';
import React, { useState, useEffect } from 'react'
import './index.css'
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _hospitalUrls } from '@custom/Utils/constants/apiUrls';
import { capitalizeWords, customStyle } from '@custom/Utils/utils';
import { useTheme } from '../../ui/src/contextProviders';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import odooApprovedApi from '@custom/rtk-apis/hospital/odooApproved';
import PricingCardSuperAdmin from './Services/PricingCardSuperAdmin';
// import { servicesManager } from 'platform/app/src/App';
import { servicesManager } from '../../app/src/App';

const Hospital = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const odooApprovedData = useSelector((state: RootState) => state?.odooApprovedResponse);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  // const [isApprovePopupOpen, setIsApprovePopupOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [hospitalToApprove, setHospitalToApprove] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState('');
  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [totalPg, setTotalPg] = useState(1000000);
  const [load, setLoad] = useState(true);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [approvedHospitals, setApprovedHospitals] = useState(new Set());
  const [selectedHospital, setSelectedHospital] = useState(null);
  const role = sessionStorage.getItem('role');
  const { isDarkMode } = useTheme();

  const { uiNotificationService } = servicesManager.services

  const onPageChangeHandler = (pg) => {
    setPgNumber(pg);
    getAllHospitalList(search, pgLimit, pg);
  };

  const handlePageSizeChange = (e) => {
    setPgLimit(e);
    getAllHospitalList(search, e, 1);
  };

  // const handleApproveHospital = (item) => {
  //   console.log("item", item._id, item.name);
  //   setHospitalToApprove({ _id: item._id, name: item.name });
  //   setIsApprovePopupOpen(true);
  // };

  // const handleApproveConfirm = () => {
  //   if (hospitalToApprove) {
  //     const hospitalId = hospitalToApprove._id;
  //     dispatch(odooApprovedApi(hospitalId));
  //     setApprovedHospitals((prev) => new Set(prev).add(hospitalId));
  //   }
  //   setIsApprovePopupOpen(false);
  //   setHospitalToApprove(null);
  // };

  // const handleApproveCancel = () => {
  //   setIsApprovePopupOpen(false);
  //   setHospitalToApprove(null);
  // };

  const columns = [
    { key: 'name', title: 'Name', sort: true },
    { key: 'email', title: 'Email', sort: true },
    { key: 'superAdmin', title: 'Super Admin', sort: true },
    { key: 'hfrId', title: 'HFR ID' },
    { key: 'contactDetails', title: 'Contact Details' },
    { key: 'healthcareProfessionals', title: 'Healthcare Professionals' },
    { key: 'services', title: 'Services' },
    { key: 'plan', title: 'Plan' },
    { key: 'actions', title: 'Action' },
  ];

  const actions = [
    // ...(role === 'Superadmin'
    //   ? [
    //       {
    //         label: 'Approve',
    //         iconName: 'approve',
    //         onClick: (item) => {
    //           handleApproveHospital(item);
    //         },
    //       },
    //     ]
    //   : []),
    {
      label: 'Edit',
      iconName: 'edit',
      onClick: (item) => {
        navigate('/addhospital', {
          state: {
            hospitalData: item?.hospitalDetail,
            isHospitalSuperAdminEditing: true,
          },
        });
      },
    },
 ...(role == 'Superadmin'
      ? [
       {
      label: 'Send Payment Link',
      iconName: 'confirm',
      onClick: (item) => {
        console.log("item", item);
        if(item?.product?.length !== 0 || item?.from || item?.from == 'odoo') {
         uiNotificationService.show({
            title: "Warning",
            type: "warning",
            message: "This hospital is already subscribed to a plan from Odoo. Please contact Odoo support for further assistance.",
            position: "topRight"
          })
          return;
        }
        setSelectedHospital(item?.hospitalDetail);
        setShowModal(!showModal);
      },
    },
      ]
      : [])
    ,
    ...(role !== 'Superadmin'
      ? [
        {
          label: 'Delete',
          iconName: 'delete',
          onClick: (item) => {
            setSelectedRow(item);
            setIsPopupOpen(true);
          },
        },
      ]
      : []),
  ];

  const handleConfirm = async () => {
    try {
      setIsPopupOpen(false);
      const response = await apiRequest({
        method: 'PUT',
        endUrl: _hospitalUrls.delete,
        headerType: 'json',
        body: { _id: selectedRow?.hospitalDetail?._id },
      });
      if (response.status) {
        setIsSuccessModal(true);
        getAllHospitalList(search, pgLimit, pgNumber);
      }
    } catch (error) {
      console.error('Error deleting hospital:', error);
    }
  };

  const handleCancel = () => {
    setIsPopupOpen(false);
    setSelectedRow(null);
  };

  const navigateToPage = () => {
    navigate('/addhospital');
  };

  const getAllHospitalList = async (search, limit, number) => {
    try {
      setLoad(true);
      const response = await apiRequest({
        method: 'GET',
        endUrl: _hospitalUrls.list,
        headerType: 'json',
        query: {
          search: search,
          limit: limit,
          offset: limit * (number - 1),
        },
      });

      if (response?.status) {
        const tempArray = response?.result?.list?.map((item) => {
          const activeServices = [];
          if (item?.telepathology) activeServices.push('Telepathology');
          if (item?.teleradiology) activeServices.push('Teleradiology');
          if (item?.speechToText) activeServices.push('Speech-to-Text');
          if (item?.aiServices) activeServices.push('AI Services');

          // Format display text
          let servicesDisplay = '--';
          let servicesTooltip = '';

          if (activeServices.length === 1) {
            servicesDisplay = activeServices[0]; // Show full name if only one
            servicesTooltip = activeServices[0];
          } else if (activeServices.length > 1) {
            servicesDisplay = `${activeServices[0]}, ...`; // First service + "..."
            servicesTooltip = activeServices.join(', '); // All services in tooltip
          }

          console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaa',item)

          return {
            _id: item?._id,
            name: item?.hospitalName ? capitalizeWords(item.hospitalName) : '--',
            superAdmin: item?.user?.name ? capitalizeWords(item?.user?.name) : '--',
            hfrId: item?.hfrId || '--',
            email: item?.hospitalEmailId || '--',
            contactDetails: `${item?.contactNumberCountryCode || ''} ${item?.contactNumber}` || '--',
            healthcareProfessionals: item?.noOfHealthCareProfessional || '--',
            services: {
              display: servicesDisplay,
              tooltip: servicesTooltip,
            },
            hospitalDetail: item,
            plan: item?.product?.length > 0 ? capitalizeWords(item?.product[0]?.name) : '--',
            from: item.from || '',
            product : item?.product || [],
          };
        });

        const approvedSet = new Set(
          response?.result?.list
            .filter((item) => item.isApproved)
            .map((item) => item._id)
        );
        setApprovedHospitals(approvedSet);
        setTableData(tempArray);
        setTotalPg(response?.result?.totalContent);
      }
    } catch (error) {
      console.error('Error fetching hospital list:', error);
    } finally {
      setLoad(false);
    }
  };

  const searchClick = (searchText) => {
    setSearch(searchText);
    setPgNumber(1);
    getAllHospitalList(searchText, pgLimit, 1);
    setSearchInputValue(searchText);
  };

  useEffect(() => {
    getAllHospitalList(search, pgLimit, pgNumber);
  }, []);

  useEffect(() => {
    if (odooApprovedData?.status) {
      getAllHospitalList(search, pgLimit, pgNumber);
      setIsSuccessModal(true);
    } else if (odooApprovedData?.error) {
      if (hospitalToApprove?._id) {
        setApprovedHospitals((prev) => {
          const newSet = new Set(prev);
          newSet.delete(hospitalToApprove._id);
          return newSet;
        });
      }
    }
  }, [odooApprovedData, search, pgLimit, pgNumber]);

  return (
    <div>
      <div className="page page__fullBody" style={isDarkMode ? { background: '#090c29' } : customStyle.mainBackground}>
        <Header isBack={false} title="Clinics & Hospitals"></Header>
        <div className="page__body">
          <div className="tableWrap">
            <div className="tableWrap__head">
              <div className="formRow formRow__3 m_0 w_100 formRow--flexEnd">
                <div className="formCol">
                  <Search
                    text="Name, Contact Details, Email ID or HFR ID"
                    onSearchClick={searchClick}
                    value={searchInputValue}
                    setValue={setSearchInputValue}
                  ></Search>
                </div>
              </div>
              <div className="btn__group">
                <button className="btn btn__white" onClick={navigateToPage}>
                  <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.63509 1.16699V12.8337M1.80176 7.00033H13.4684"
                      stroke="#150823"
                      strokeWidth="1.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Add Clinic or Hospital
                </button>
              </div>
            </div>
            <div className="tableContainer">
              {load ? (
                <Loader isLoaderOpen={load} />
              ) : (
                <CustomTable
                  columns={columns}
                  data={tableData}
                  actions={actions}
                  searchQuery={searchQuery}
                  from="hospital"
                  approvedHospitals={approvedHospitals}
                />
              )}
            </div>
          </div>
        </div>
        {tableData.length > 0 && (
          <Pagination
            onChangePage={onPageChangeHandler}
            onChangePerPage={handlePageSizeChange}
            totalPage={totalPg}
            currentPage={pgNumber}
            perPage={pgLimit}
          />
        )}
      </div>
      <ConfirmationPopup
        isOpen={isPopupOpen}
        message={`Are you sure you want to delete ${selectedRow?.name}?`}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={`Hospital ${selectedRow ? 'deleted' : 'approved'} successfully.`}
        handleCloseModal={() => setIsSuccessModal(false)}
      />
      <PricingCardSuperAdmin
        showModal={showModal}
        loading={loading}
        setLoading={setLoading}
        selectedHospital={selectedHospital}
        setShowModal={setShowModal}
      />
    </div>
  )
}

export default Hospital
